import React, { useState } from "react";
import { Link } from "react-router-dom";
import Options from "./Options";
import History from "../history/History";
import OtamiSynchronized from "../page/content/product/OtamiSynchronized";
import StoreSetting from "../../stories/_setting/StoreSettings/StoreSetting";
import "../../css/toolsBar/provider/ToolsBar.css";
import "../../css/toolsBar/brand/ToolsBar.css";
import "../../css/toolsBar/category/ToolsBar.css";
import "../../css/toolsBar/subcategory/ToolsBar.css";
import "../../css/toolsBar/menu/ToolsBar.css";
import "../../css/toolsBar/product/ToolsBar.css";
import "../../css/toolsBar/productionmessage/ToolsBar.css";
import "../../css/toolsBar/filter/ToolsBar.css";
import "../../css/toolsBar/group/ToolsBar.css";
import "../../css/toolsBar/client/ToolsBar.css";
import "../../css/toolsBar/sellergroup/ToolsBar.css";
import "../../css/toolsBar/seller/ToolsBar.css";
import "../../css/toolsBar/paymentmethod/ToolsBar.css";
import "../../css/toolsBar/pricelist/ToolsBar.css";
import "../../css/toolsBar/printer/ToolsBar.css";
import "../../css/toolsBar/display/ToolsBar.css";
import "../../css/toolsBar/barcodereader/ToolsBar.css";
import "../../css/toolsBar/automaticdrawer/ToolsBar.css";

const ToolsBarV2 = props => {
    const { item, title, options, secondaryOptions, activeHistory, handleOption } = props;
    const [ showOption, setShowOption ] = useState(false);

    const handleShowOption = () => {
        setShowOption(!showOption);
    }
    const handleAction = action => {
        handleShowOption();
        handleOption(action);
    }
    const buildOtamiSynchronizer = () => {
        if (localStorage.getItem("storeSettings") === null)
            return;

        const settings = new StoreSetting(JSON.parse(localStorage.getItem("storeSettings")));

        if (item === "products" && settings.otamiApiKey !== null && !settings.otamiSynchronized)
            return <OtamiSynchronized />
    }

    return(
        <>
            {
                ((title !== undefined && title !== null) || options.length > 0)
                && <div className="toolsBarV2">
                    <div className={"container"}>
                        <p className="titleToolsBar">{ (title !== undefined && title !== null) ? title : "" }</p>
                        <div className={"actions"}>
                            {
                                activeHistory
                                && <History type={item} classname="history"/>
                            }
                            {
                                buildOtamiSynchronizer()
                            }
                            {
                                options.map((option, index) => (
                                    (option.action !== undefined && option.action !== "")
                                        ? <button key={index} className={"button " + option.class} onClick={option.action}><span>{option.title}</span></button>
                                        : <Link key={index} to={option.link}>
                                            <button className={"button " + option.class}><span>{option.title}</span></button>
                                        </Link>
                                ))
                            }
                            {
                                secondaryOptions.length > 0
                                && <div className="optionButton arrow" onClick={handleShowOption} />
                            }
                            {
                                secondaryOptions.length > 0
                                && <Options item={item} show={showOption} options={secondaryOptions} handleAction={handleAction}/>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default ToolsBarV2;
